import { Component } from "react";

class RefreshStateManager extends Component {
  constructor() {
    super();

    this.state = {
      refreshing: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const isRefreshing =
      nextProps.location &&
      nextProps.location.state &&
      nextProps.location.state.refreshing;

    if (!this.state.refreshing && isRefreshing) {
      this.setState((state) => ({ refreshing: true }));
    } else if (this.state.refreshing && isRefreshing) {
      this.setState((state) => ({ refreshing: false }));
      this.props.history.replace({
        ...this.props.location,
        state: {
          ...this.props.location.state,
          refreshing: false,
        },
      });
    }
  }

  render() {
    return null;
  }
}

export default RefreshStateManager;
